export const ArrowRightInCircleIcon = ({
  className = 'w-4 h-4',
}: {
  className?: string;
}) => (
  <svg
    className={className}
    height="16"
    viewBox="0 0 16 16"
    width="16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="8" cy="8" r="8" fill="#100868" />
    <path
      d="M7.99877 3.36816L7.18245 4.18448L10.413 7.4208H3.36719V8.57869H10.413L7.18245 11.815L7.99877 12.6313L12.6303 7.99974L7.99877 3.36816Z"
      fill="#F2F2F2"
    />
  </svg>
);
